<template>
  <article></article>
</template>

<script>
export default {
  name: "Home",
  mounted() {
  },
}
</script>

<style scoped></style>
